import React, { useEffect, useState } from 'react';
import CheckboxList, { FilterListItem } from '../CheckboxList';
import { FieldValues, Path } from 'react-hook-form';
import { cameraService } from '../../../services/central-api/cameras';
import { useCurrentApp } from '../../../context/CurrentApp';
import FilterDependencyMessage from '../../Filters/FilterDependencyMessage';
import { translate } from '../../../services/translate';

function CameraTagList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name, companyId }: { name: TName; companyId?: number | null; }) {
    const { isParentApp } = useCurrentApp();
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getCameraTags() {
        try {
            setIsLoading(true);
            const tags = await cameraService.getCameraTagsSimplified(isParentApp && companyId ? companyId : undefined);
            setItems(tags.map((tag) => ({ value: tag.id, label: tag.name, color: tag.color })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (isParentApp && !companyId) {
            return;
        }
        getCameraTags();
    }, [companyId]);

    if (isParentApp && !companyId) {
        return <FilterDependencyMessage message={translate('selectCompanyFirst')} />;
    }

    return <CheckboxList items={items} name={name} renderBadge isLoading={isLoading} />;
}

CameraTagList.getCount = CheckboxList.getCount;

export default CameraTagList;
